<template>

    <div class="cart__item">
        <a v-bind:href="product.attributes.detail_url" class="image-wrapper">
            <div class="filter"></div>
            <img v-bind:src="product.attributes.pic_url" />
        </a>
        <div class="cart__item__info">
            <a v-bind:href="product.attributes.detail_url" class="cart__item__name">
                {{ product.attributes.name }}
            </a>
            <div class="not-saleable" v-if="product.attributes.salable === false">{{ strings['price_error'] }}</div>
            <span class="cart-item-code">{{ product.attributes.product_code }}</span>
            <div class="cart-item-color" v-if="!product.attributes.is_giftcard">
                {{ strings['color'] }}: <span class="details-value">{{ product.attributes.description_color }}</span>
            </div>
            <div class="cart-item-size">
                {{ strings['size'] }}: <span class="details-value">{{ product.attributes.size }}</span>
            </div>
        </div>
        <div class="cart__item__prices">

            <div class="item__quantity">
                <button type="button" v-on:click="$emit('remove')">
                    <svg viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.833496 0.0777508H4.51621H4.8373L5.4057 0.0776367L6.13109 0.0777508H9.8335V1.63355H6.13109H5.66148L4.8373 1.63348L4.51621 1.63355H0.833496V0.0777508Z"
                            fill="black" />
                    </svg>
                </button>
                <div class="quantity-value">
                    {{ product.quantity }}
                </div>
                <button type="button" v-on:click="$emit('add')">
                    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.42627 4.07757H4.10898V0.237305H5.72386V4.07757H9.42627V5.63337H5.72386V9.51301H4.10898V5.63337H0.42627V4.07757Z" fill="black" />
                    </svg>

                </button>
            </div>

            <div class="prices__wrapper">
                <div class="cart-item-baseprice" v-if="product.attributes.is_on_sale">
                    {{ product.attributes.base_price }} {{ currency }}
                </div>
                <div class="cart-item-baseprice before-promo" v-else-if="product.attributes.is_on_promo">
                    {{ product.attributes.price_original }} {{ currency }}
                </div>
                <div class="cart-item-price">
                    {{ product.attributes.price }} {{ currency }}
                </div>
            </div>
        </div>
    </div>


    <!-- <div class="cart-item row">
        <div class="cart-item-image text-center">
            <a v-bind:href="product.attributes.detail_url" class="image-wrapper">
                <div class="filter"></div>
                <img v-bind:src="product.attributes.pic_url" />
            </a>
        </div>
        <div>
            <div class="cart-item-info">
            <div class="cart-item-infofirst">
                <a class="cart-item-name" v-bind:href="product.attributes.detail_url">
                    {{ product.attributes.name }}
                </a>
                <div class="dark-red pb1" v-if="product.attributes.salable === false">{{ strings['price_error'] }}</div>
                <span class="cart-item-code">{{ product.attributes.product_code }}</span>
            </div>
            <div class="cart-item-infoadd">
                <div class="cart-item-color">
                    {{ strings['color'] }}: {{ product.attributes.description_color }}
                </div>
                <div class="cart-item-size">
                    {{ strings['size'] }}: {{ product.attributes.size }}
                </div>
                <div class="cart-item-promoprice" v-if="product.attributes.is_on_promo">
                    {{ strings['discount_applied'] }}: {{ product.attributes.promo_discount }}
                </div>
            </div>

            <div class="cart-item-prices">
                    <div class="cart-item-baseprice" v-if="product.attributes.is_on_sale">
                        {{ currency }} {{ product.attributes.base_price }}
                    </div>
                    <div class="cart-item-baseprice before-promo" v-else-if="product.attributes.is_on_promo">
                        {{ currency }} {{ product.attributes.price_original }}
                    </div>
                    <div class="cart-item-price">
                        {{ currency }} {{ product.attributes.price }}
                    </div>
                </div>
        </div>
        <div class="cart-item-numbers" style="display: none !important;" v-if="product.attributes.salable === true">
            <div class="col">
                <div class="hidden-xs col-sm-6 cart-item-quantity-container">
                    <div class="cart-item-quantity">
                        <div class="cart-item-quantity-label">{{ strings['quantity'] }}:</div>
                        <div class="cart-item-quantity-minus" v-on:click="$emit('remove')"><i class="fa fa-minus"></i></div>
                        <div class="cart-item-quantity-number"><span class="cart-item-quantity-number-num">{{ product.quantity }}</span><i class="fa fa-spinner fa-pulse"></i></div>
                        <div class="cart-item-quantity-plus" v-on:click="$emit('add')"><i class="fa fa-plus"></i></div>
                        <div class="cart-item-quantity-error">
                            <i class="fa fa-exclamation-triangle"></i>
                            <div class="error-msg"></div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 cart-item-prices">
                    <div class="cart-item-baseprice" v-if="product.attributes.is_on_sale">
                        {{ currency }} {{ product.attributes.base_price }}
                    </div>
                    <div class="cart-item-baseprice before-promo" v-else-if="product.attributes.is_on_promo">
                        {{ currency }} {{ product.attributes.price_original }}
                    </div>
                    <div class="cart-item-price">
                        {{ currency }} {{ product.attributes.price }}
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div> -->
</template>

<script>
module.exports = {
    props: ['product', 'currency', 'strings', 'recap'],
}
</script>
